import axios from 'axios';

let baseURL = "";

if (window.location.hostname === 'localhost') {
  baseURL = 'http://localhost:8000';
} else {
  baseURL = 'https://api.lucrotech.appandwebstudio.com.br';
}

const api = axios.create({
  baseURL,
});

export default api;
